import BottomNav from "components/bottomnav";
import React from "react";
import { Outlet } from "react-router";

function PatientLayout() {
  return (
    <div className="relative">
      <div className="overflow-y-auto h-screen">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}

export default PatientLayout;
